function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.21947 4.27804H4.84903C4.98966 4.27804 5.10365 4.16405 5.10365 4.02342C5.10365 3.88279 4.98966 3.7688 4.84903 3.7688H3.21947C3.07884 3.7688 2.96484 3.88279 2.96484 4.02342C2.96484 4.16405 3.07886 4.27804 3.21947 4.27804Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.37678 5.42383H3.21947C3.07884 5.42383 2.96484 5.53782 2.96484 5.67845C2.96484 5.81908 3.07884 5.93307 3.21947 5.93307H6.37676C6.51739 5.93307 6.63138 5.81908 6.63138 5.67845C6.63138 5.53782 6.51739 5.42383 6.37678 5.42383Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.37678 7.07886H3.21947C3.07884 7.07886 2.96484 7.19285 2.96484 7.33348C2.96484 7.47411 3.07884 7.5881 3.21947 7.5881H6.37676C6.51739 7.5881 6.63138 7.47411 6.63138 7.33348C6.63138 7.19285 6.51739 7.07886 6.37678 7.07886Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0195 8.9885V0.967926C10.0408 0.4551 9.64233 0.0221048 9.12951 0.000807093C9.10791 -9.45244e-05 9.08628 -0.000240733 9.06469 0.000368468H3.59031C3.03014 0.000368468 2.50817 0.407753 2.50817 0.967926V1.40078H2.0626C1.48011 1.41357 1.0071 1.87544 0.980469 2.45745V10.4907C0.997039 10.646 1.09363 10.7812 1.23509 10.8472C1.38152 10.9119 1.55251 10.8817 1.66794 10.7708L2.44452 10.0706L3.3739 10.8981C3.44322 10.9624 3.53397 10.9987 3.62852 11C3.7226 10.9965 3.81259 10.9605 3.88314 10.8981L4.79977 10.0706L5.7164 10.8981C5.86139 11.0278 6.08065 11.0278 6.22564 10.8981L7.15501 10.0706L7.91888 10.7708C8.01135 10.8846 8.17167 10.9167 8.3008 10.8472C8.42729 10.7746 8.50139 10.6363 8.49177 10.4907V8.68292L8.64453 8.56834L9.42112 9.26856C9.49293 9.33706 9.58928 9.37378 9.68846 9.37041C9.73247 9.37439 9.77667 9.36554 9.81576 9.34495C9.94961 9.27833 10.03 9.1376 10.0195 8.9885ZM7.98253 10.2107L7.38417 9.62504C7.24934 9.48721 7.02937 9.48158 6.88765 9.61232L5.95827 10.4398L5.05437 9.61232C4.90553 9.49316 4.69396 9.49316 4.54512 9.61232L3.62849 10.4398L2.69912 9.61232C2.53856 9.48073 2.30597 9.48614 2.15169 9.62504L1.48969 10.2107V2.45747C1.51515 2.15657 1.76083 1.92181 2.06258 1.91004H7.53693C7.81702 1.91004 7.98253 2.17738 7.98253 2.45747V10.2107ZM9.51026 0.967926V8.70841L8.87371 8.12277C8.77186 8.02091 8.74642 7.99547 8.49179 8.03366V2.45747C8.49179 1.8973 8.09713 1.4008 7.53696 1.4008H3.01742V0.967926C3.01742 0.68784 3.31022 0.509612 3.59031 0.509612H9.06466C9.29621 0.494552 9.49612 0.670027 9.51118 0.901572C9.51264 0.923673 9.51233 0.945873 9.51026 0.967926Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: "1em",
  height: "1em",
  fill: "currentColor"
})));

function SvgReceipticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipticon);
export default __webpack_public_path__ + "static/media/receipt.icon.68f3c7e4.svg";
export { ForwardRef as ReactComponent };